<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="title">{{ pageTitle | uppercase }}</div>
<div fxLayout="row" class="cards row">
  <app-dashboard-card
    [loading]="loading"
    cardTitle="Total Time"
    i18n-cardTitle="@@totalTime"
    [cardContent]="totalTime"
    type="Hours"
    i18n-type="@@employeeDashboardHours"
    [pipe]="'1.2-2'"
    [color]="'#6c8f80'"
  ></app-dashboard-card>

  <app-dashboard-card
    [loading]="loading"
    cardTitle="Number Of Tasks"
    i18n-cardTitle="@@numberOfTasks"
    [cardContent]="numberOfTasks"
    type="Tasks"
    i18n-type="@@employeeDashboardTasks"
    [color]="'#d89849'"
  ></app-dashboard-card>

  <app-dashboard-card
    [loading]="loading"
    cardTitle="Number Of Checkpoints"
    i18n-cardTitle="@@numberOfCheckpoints"
    [cardContent]="numberOfCheckpoints"
    type="Checkpoints"
    i18n-type="@@employeeDashboardCheckpoints"
    [color]="'#c06a68'"
  ></app-dashboard-card>
</div>

<div class="graph-cards">
  <div fxLayout="row">
    <div class="table-card">
      <mat-card>
        <mat-card-title i18n="@@listOfTasks"> List Of Tasks </mat-card-title>
        <mat-card-content>
          <section style="height: 217px; overflow: auto">
            <table mat-table [dataSource]="taskList" class="mat-elevation-z" style="width: 100%">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef i18n="@@name">Name</th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
              </ng-container>

              <ng-container matColumnDef="totalTime">
                <th mat-header-cell *matHeaderCellDef i18n="@@totalTime">Total Time</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.totalTime | number: '1.2-2' }} <span i18n="@@employeeDashboardHours">Hours</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="medianTime">
                <th mat-header-cell *matHeaderCellDef i18n="@@medianTime">Median Time</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.medianTime | number: '1.2-2' }} <span i18n="@@employeeDashboardHours">Hours</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </section>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="distribution-graph-card">
      <mat-card>
        <mat-card-title style="padding: 0">
          <div fxLayout="row" class="distribution-header">
            <div style="width: 60%; padding: 20px" i18n="@@normalDistributionGraph">
              Normal Distribution Graph
            </div>
            <div style="width: 40%; float: left">
              <mat-form-field class="filter_field" appearance="outline" subscriptSizing="dynamic">
                <mat-label i18n="@@checkpointDropDown">Checkpoint</mat-label>
                <mat-select
                  class="dropdown"
                  [(ngModel)]="taskId"
                  (selectionChange)="changeDistributionGraph($event.value)"
                >
                  <mat-option [value]="''" i18n="@@allCheckpoints">All Checkpoints</mat-option>
                  <mat-option *ngFor="let check of checkPointList" [value]="check.name">
                    {{ check.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card-title>
        <mat-card-content>
          <div style="padding-top: 20px">
            <p-chart
              *ngIf="distributionGraphDataObject"
              type="line"
              width="402"
              height="218"
              [data]="distributionGraphDataObject.distGraphData"
              [options]="distributionGraphDataObject.distGraphOptions"
            ></p-chart>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="bar-chart-card">
    <mat-card>
      <mat-card-title i18n="@@barChartGraph"> Bar Chart Graph </mat-card-title>
      <mat-card-content>
        <div>
          <p-chart
            *ngIf="barChartDataObject"
            height="218"
            type="bar"
            [data]="barChartDataObject.barChartData"
            [options]="barChartDataObject.barChartOptions"
          ></p-chart>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
